// src/components/meeting/panels/MobileDetailPanel.jsx
import MobileMeetingDetailCard from "../MobileMeetingDetailCard";

export default function MobileDetailPanel({
  item,
  projectId,
  onEdit,
  onDeleted,
  onClose, // 필요 시 버튼에서 사용
}) {
  if (!item) return null;
  return (
    <MobileMeetingDetailCard
      item={item}
      projectId={projectId}
      onEdit={onEdit}
      onDeleted={onDeleted}
    />
  );
}

